module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-pt-PT.4ec725ab.jpg";